import { MenuItem } from "@mantine/core"
import { IconBrandChrome } from "@tabler/icons-react"
import Link from "next/link"

export function MenuItemInstallExtensionButton({ id }: { id: string }) {
  return (
    <MenuItem
      leftSection={
        <IconBrandChrome
          className="size-4"
          data-testid="menu-item-install-chrome-extension-btn"
        />
      }
      component={Link}
      href={`https://chromewebstore.google.com/detail/ringio-web-phone-newtesti/${id}`}
      target="_blank"
    >
      Chrome Extension
    </MenuItem>
  )
}
